/**
 * Confirm Dialog Component
 * 
 * Confirmation modal with actions
 * 
 * Version: 6.2.0
 */
import React from 'react'
import Modal from './Modal'

interface ConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  type?: 'danger' | 'warning' | 'info' | 'success'
  loading?: boolean
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'danger',
  loading = false
}) => {
  const icons: Record<string, string> = {
    danger: '⚠️',
    warning: '⚡',
    info: 'ℹ️',
    success: '✓'
  }

  const confirmButtons: Record<string, string> = {
    danger: 'btn-danger',
    warning: 'btn-warning',
    info: 'btn-primary',
    success: 'btn-success'
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      showClose={false}
      closeOnOverlay={!loading}
      closeOnEscape={!loading}
    >
      <div className="confirm-dialog">
        <div className={`confirm-icon ${type}`}>
          {icons[type]}
        </div>
        
        <h3 className="confirm-title">{title}</h3>
        
        <p className="confirm-message">{message}</p>
        
        <div className="confirm-actions">
          <button 
            className="btn btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          
          <button 
            className={`btn ${confirmButtons[type]}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <span className="btn-loading">
                <span className="spinner" />
                Processing...
              </span>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmDialog